module.exports = __webpack_public_path__ + "img/ps-39-OUT.ae610d53.jpg";